<h1 mat-dialog-title *ngIf="data.title"><b>{{data.title}}</b></h1>
<hr *ngIf="data.content && data.title" />
<mat-dialog-content class="mat-typography">
  <p *ngIf="data.content">{{data.content}}</p>
  <p *ngIf="data.content2">{{data.content2}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-raised-button
  color="primary" [mat-dialog-close]="true">{{data.acceptText}}</button>
  <button color="accent" mat-button mat-raised-button [mat-dialog-close]="false">{{data.declineText}}</button>
</mat-dialog-actions>